import { AudioWaveform, Bike, Captions, Car, Clapperboard, MonitorPlay, ScanFace, Scissors, ShieldCheck, Smartphone, SquareDashed, Subtitles, type LucideIcon } from 'lucide-react';
import type { BuiltInPresetId } from '@/core/project/preset';

/** One glyph per built-in recipe, shared by the recipe list and the home page's one-job choices. */
export const PRESET_ICONS: Readonly<Record<BuiltInPresetId, LucideIcon>> = {
  recording: MonitorPlay,
  reels: Smartphone,
  youtube: Clapperboard,
  motovlog: Bike,
  privacy: ShieldCheck,
  faces: ScanFace,
  plates: Car,
  fillers: AudioWaveform,
  captions: Captions,
  blank: SquareDashed,
  silence: Scissors,
  subtitles: Subtitles,
};
